
import React from 'react';
import { Helmet } from 'react-helmet';
import RefundPolicy from '../components/refundpolicy';
import Navigation from '../components/navigation'
import Footer from '../components/footer'
const RefundPolicyPage = (props) => {
  return (
    <div className='container'>
            <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta property="og:title" content="Cysigil Network Pvt Ltd" />
        <link
          rel="canonical"
          href="https://www.cysigil.com"
        />
      </Helmet>
      <Navigation />
        <RefundPolicy />
        <Footer />
    </div>
      
  );
};

export default RefundPolicyPage;
